import { useEffect, useRef, useState } from "react";
import axios from "axios";
import useTranslator from "../../hooks/useTranslator";
import { Button, PublicPage, PublicPageStatus } from "../../components/design";

const STATUS = {
  VALIDATING: "validating",
  REDIRECTING: "redirecting",
  ERROR: "error",
};

// Landing page for login links in tenant emails (backend
// buildTenantEmailLoginUrl). Trades the link token for a session and the
// page the link points to, then hands off to /redirect.
const TenantEmailLogin = () => {
  const { _t } = useTranslator();
  const requestStarted = useRef(false);
  const [status, setStatus] = useState(STATUS.VALIDATING);

  useEffect(() => {
    if (requestStarted.current) return;
    requestStarted.current = true;

    const params = new URLSearchParams(window.location.search);
    const emailToken = params.get("token");

    window.history.replaceState({}, "", window.location.pathname);

    if (!emailToken) {
      setStatus(STATUS.ERROR);
      return;
    }

    const validateLink = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/tenant-email-login/${encodeURIComponent(
            emailToken
          )}`,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng") || "en",
            },
          }
        );
        const redirectUrl = response.data?.success_res?.redirectUrl;

        if (!redirectUrl) {
          setStatus(STATUS.ERROR);
          return;
        }

        setStatus(STATUS.REDIRECTING);
        window.location.replace(redirectUrl);
      } catch {
        setStatus(STATUS.ERROR);
      }
    };

    validateLink();
  }, []);

  return (
    <PublicPage width="sm">
      {status === STATUS.ERROR ? (
        <PublicPageStatus
          tone="danger"
          title={_t("unableToProcessRequest")}
          description={_t("emailLoginLinkInvalid")}
        >
          <Button size="lg" block onClick={() => window.location.replace("/")}>
            {_t("goToHome")}
          </Button>
        </PublicPageStatus>
      ) : (
        <PublicPageStatus
          title={
            status === STATUS.REDIRECTING ? _t("redirecting") : _t("pleaseWait")
          }
        />
      )}
    </PublicPage>
  );
};

export default TenantEmailLogin;
